module.exports = __webpack_public_path__ + "static/img/lunbo2.6618ae71.webp";